import {
  Flex,
  Text,
  Button,
  TextButton,
  IconToggleGroup,
  IconToggle,
  IconSearch,
  IconChevronDown,
  IconSquare,
  IconList,
  IconColumnAndRows,
  IconPlus,
} from '@flodesk/grain';
import { TopNav } from '@/components/app/TopNav';
import { EmailCard } from '@/components/ui/EmailCard';

const EMAILS = [
  {
    id: '1',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/5e27d778-5aa6-404d-b0eb-a0d131175e7c',
    badge: 'Draft last edited 2 hours ago',
  },
  {
    id: '2',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/bd83b0e3-13c7-4628-80df-77786908553e',
    badge: 'Draft last edited 2 hours ago',
  },
  {
    id: '3',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/eadbf575-8f77-4894-9c38-ad7e353a7146',
    badge: 'Draft last edited 2 hours ago',
  },
  {
    id: '4',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/f1d76e40-8dd9-4591-944c-dd551fa9576e',
    badge: 'Draft last edited 2 hours ago',
  },
  {
    id: '5',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/dc7f7833-b456-4bdc-93c8-9afda849a82a',
    badge: 'Draft last edited 2 hours ago',
  },
  {
    id: '6',
    title: 'Personal welcome message',
    imageUrl: 'https://www.figma.com/api/mcp/asset/960cdfc6-3ccf-497e-a19a-7bdda0661cf1',
    badge: 'Draft last edited 2 hours ago',
  },
];

export default function Home() {
  return (
    <Flex direction="column" minHeight="100vh">
      <TopNav />

      <Flex
        direction="column"
        backgroundColor="#f9f9f6"
        paddingX="150px"
        paddingY="xxl"
        rowGap="xl2"
        flex="1"
      >
        {/* Header */}
        <Flex justifyContent="space-between">
          <Flex columnGap="l">
            <Text tag="h1" size="xl" weight="medium" color="#10100f">
              My emails
            </Text>
            <Text tag="span" size="xl" weight="medium" color="rgba(61,46,41,0.52)">
              Folders
            </Text>
          </Flex>

          <Flex columnGap="m">
            <Flex columnGap="s">
              <TextButton icon={IconSearch}>Search</TextButton>
              <TextButton icon={IconChevronDown} iconPosition="right">
                Status
              </TextButton>
            </Flex>
            <IconToggleGroup>
              <IconToggle icon={IconSquare} isActive />
              <IconToggle icon={IconList} />
              <IconToggle icon={IconColumnAndRows} />
            </IconToggleGroup>
            <Button variant="accent" icon={IconPlus}>
              New email
            </Button>
          </Flex>
        </Flex>

        {/* Email cards grid */}
        <Flex wrap="wrap" columnGap="56px" rowGap="56px">
          {EMAILS.map(email => (
            <EmailCard
              key={email.id}
              title={email.title}
              imageUrl={email.imageUrl}
              badge={email.badge}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
